import { render, staticRenderFns } from "./SourceTargetInteraction.vue?vue&type=template&id=5dc419d8&scoped=true&"
import script from "./SourceTargetInteraction.vue?vue&type=script&lang=js&"
export * from "./SourceTargetInteraction.vue?vue&type=script&lang=js&"
import style0 from "./SourceTargetInteraction.vue?vue&type=style&index=0&id=5dc419d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc419d8",
  null
  
)

export default component.exports